var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer footer2"},[_c('div',{staticClass:"wrapcontainer"},[_vm._v("\n        COPYRIGHT © "+_vm._s(new Date().getFullYear())+" 星亿娱乐 版权所有 All Rights Reserved\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }